import { useId, useRef } from 'react';

import { ChipsProps, SelectProps, useValueTracker } from '@xemplo/base-multi-select';
import { V2Types } from '@xemplo/popover';
import { MultiSelectInputProps } from '@xemplo/stateful-list';

import { TextDropdownMultiProps } from '../text-dropdown-multi.types';

export function useMultiSelect(props: TextDropdownMultiProps) {
  const internalId = useId();
  const triggerId = `${internalId}${props.name}`;
  const listboxId = `${internalId}${props.name}-listbox`;
  const popoverRef = useRef<V2Types.PopoverRef>(null);
  const valueTracker = useValueTracker(props);

  const chipsProps = {
    value: valueTracker.valueListItems,
    disabled: props.disabled,
    readOnly: props.readOnly,
    onRemove: valueTracker.removeItem,
    onClear: valueTracker.clear,
  } satisfies ChipsProps;

  const selectProps = {
    ...props,
    triggerId,
    listboxId,
    hasValue: valueTracker.hasValue,
    value: valueTracker.internalValue,
    chipsProps,
  } satisfies Omit<SelectProps, 'open'>; // 'open' is provided by Popover.Trigger

  const listProps = {
    id: listboxId,
    items: props.items,
    onChange: valueTracker.handleChange,
    triggerId: triggerId,
    value: valueTracker.internalValue,
    onSearchChange: props.onSearchChange,
    searchPlaceholder: props.searchPlaceholder,
    useSearch: props.useSearch,
    useSelectAll: props.useSelectAll,
  } satisfies MultiSelectInputProps;

  return {
    ...props,
    triggerId,
    listboxId,
    popoverRef,
    selectProps,
    listProps,
    hasValue: valueTracker.hasValue,
    handleChange: valueTracker.handleChange,
  };
}
